import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Account } from './model/account.interface';
import { isNotEmpty, isUUID, ValidateParameters } from '../../parameter-validators';
import { HeaderForAuthentication } from './model/header-for-authentication.model';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthApiAccountService {
  constructor(private http: HttpClient) {
  }

  @ValidateParameters
  readAccessibleAccounts$(@isUUID accountId: string, params?: any): Observable<Account[]> {
    const url = '/cloud-service-auth/accounts';
    const options = {
      headers: new HeaderForAuthentication(),
      params: {
        ...params,
        id: accountId,
      },
    };
    return this.http.get<Account[]>(url, options);
  }

  @ValidateParameters
  readAccessibleAccountIds$(@isNotEmpty accountIds: string[], params?: any): Observable<string[]> {

    const url = '/cloud-service-auth/accounts';
    const options = {
      headers: new HeaderForAuthentication(),
      params: {
        ...params,
        select: 'id',
        id: accountIds,
      },
    };
    return this.http.get<string[]>(url, options);
  }

  readProjectsById$(ids: string[]): Observable<Account[]> {
    let idString = '';
    if ( ids.length !== 0) {
      idString = '&id=';
    }
    idString += ids.join(',');

    const url = '/cloud-service-auth/accounts?property=name,id,identifier&sort=name,asc&type=PROJECT' + idString;
    const options = {
      headers: new HeaderForAuthentication(),
    };
    return this.http.get<Account[]>(url, options);
  }

  readProjectById$(id: string): Observable<Account> {
    const url = '/cloud-service-auth/accounts?property=name,id,identifier&sort=name,asc&type=PROJECT&id=' + id;
    const options = {
      headers: new HeaderForAuthentication(),
    };
    return this.http.get<Account[]>(url, options).pipe(map(accounts => accounts[0]));
  }

  readProjectIds$(nameLike: string): Observable<string[]> {
    const url = '/cloud-service-auth/accounts?select=id&type=PROJECT&sort=name,asc&nameLike=' + nameLike;
    const options = {
      headers: new HeaderForAuthentication(),
    };
    return this.http.get<string[]>(url, options);
  }

  @ValidateParameters
  readAccount$(@isUUID accountId: string, params?: any): Observable<Account> {
    const url = `/cloud-service-auth/accounts/${accountId}`;
    const options = {
      headers: new HeaderForAuthentication(),
      params,
    };
    return this.http.get<Account>(url, options);
  }
}
